import React from 'react';
import { Wifi, Car, Dumbbell } from 'lucide-react';

const amenitiesList = [
    { icon: Wifi, title: "Smart Living", desc: "High-speed fiber & smart home integration" },
    { icon: Car, title: "Valet Parking", desc: "24/7 valet service with secure parking" },
    { icon: Dumbbell, title: "Wellness Center", desc: "State-of-the-art gym & yoga studio" },
];

const HorizontalAmenities = () => {
    return (
        <div className="horizontal-panel amenities-panel">
            <div className="amenities-panel-content">
                {/* Left Content */}
                <div className="amenities-text-content welcome-section">
                    <h1 className="welcome-title animate-fade-in">Welcome to Hollywood Royale Garden</h1>
                    <p className="welcome-text animate-fade-in">
                        Hollywood Royale Garden, an assisted living community, is designed to create opportunities for residents to feel at home, surrounded by familiar spaces and staff who will support personal needs. We offer both private and shared rooms including lovely patios and balconies.
                    </p>
                    <button className="outline-btn">Explore All Amenities →</button>
                </div>

                {/* Right Grid */}
                <div className="amenities-grid-horizontal">
                    {amenitiesList.map((item, i) => (
                        <div key={i} className="amenity-card-h">
                            <div className="icon-wrapper">
                                <item.icon size={28} strokeWidth={1.5} />
                            </div>
                            <h3>{item.title}</h3>
                            <p>{item.desc}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* Animated GIF (turbine) */}
            {/* <img src="/seniorcitigen.gif" alt="Turbine animation" className="turbine-gif" loading="lazy" decoding="async" /> */}
        </div>
    );
};

export default HorizontalAmenities;
